import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getHomeDashboard() {
  return apiRequest('/api/dashboard/home', {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}

export async function searchDashboardCourses(query) {
  const q = String(query || '').trim();
  if (!q) {
    return { success: true, message: '', data: { courses: [] } };
  }

  const params = new URLSearchParams({ q });
  return apiRequest(`/api/dashboard/search?${params.toString()}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}
